export const STARTED_FETCH_TRANSPORT_ORDER_REPORT = 'STARTED_FETCH_TRANSPORT_ORDER_REPORT';
export const FINISHED_FETCH_TRANSPORT_ORDER_REPORT = 'FINISHED_FETCH_TRANSPORT_ORDER_REPORT';

export interface FinishedFetchTransportOrderReportAction {
    type: typeof FINISHED_FETCH_TRANSPORT_ORDER_REPORT;
}

export interface StartedFetchTransportOrderReportAction {
    type: typeof STARTED_FETCH_TRANSPORT_ORDER_REPORT;
}

export type TransportOrderReportActions =
    | FinishedFetchTransportOrderReportAction
    | StartedFetchTransportOrderReportAction;
